import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = 'rm_aff_code';
const COOKIE_DAYS = 30;

const _readStored = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.code || !data?.expires_at) return null;
    if (Date.now() > data.expires_at) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

const _storeCode = (code, targetType, targetId) => {
  try {
    const expires_at = Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      code: String(code).toUpperCase(),
      target_type: targetType || 'global',
      target_id: targetId || null,
      stored_at: Date.now(),
      expires_at,
    }));
  } catch {
    /* ignore */
  }
};

// Public helper for the checkout flow
export const getAffiliateCode = () => {
  const data = _readStored();
  return data?.code || null;
};

/**
 * Mounted once at the top of App. Detects ?aff=CODE in URL, stores in localStorage,
 * fires a backend track-click event, then continues.
 */
export const AffiliateTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('aff');
    if (!code) return;
    const trimmed = code.trim().toUpperCase();
    if (trimmed.length < 4 || trimmed.length > 20) return;

    // Detect target_type from current path
    let target_type = 'global';
    let target_id = null;
    const path = location.pathname;
    if (path.startsWith('/product/')) {
      target_type = 'product';
      target_id = path.split('/')[2] || null;
    } else if (path.startsWith('/vendor/')) {
      target_type = 'vendor';
      target_id = path.split('/')[2] || null;
    }

    _storeCode(trimmed, target_type, target_id);

    // Fire-and-forget click track
    axios.post(`${API}/affiliates/track-click`, {
      code: trimmed,
      target_type,
      target_id,
      referrer: document.referrer || null,
    }).catch(() => { /* silent */ });
  }, [location.pathname, location.search]);

  return null;
};
